import React from 'react';
import { motion } from 'framer-motion';
const ProblemSection: React.FC = () => {
  return <section className="w-full bg-white py-16" data-id="element-193">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary text-center mb-10" data-id="element-196">
            ¿Te reconoces aquí?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-197">
            <div className="bg-background p-6 rounded-lg shadow-md" data-id="element-198">
              <p className="mb-2" data-id="element-199">
                <span className="text-primary font-medium" data-id="element-200">✓</span> Comes azúcar
                "por impulso".
              </p>
              <p className="mb-2" data-id="element-201">
                <span className="text-primary font-medium" data-id="element-202">✓</span> Te sientes
                hinchada y cansada cada día.
              </p>
              <p className="mb-2" data-id="element-203">
                <span className="text-primary font-medium" data-id="element-204">✓</span> Tu humor
                cambia según lo que comes.
              </p>
            </div>
            <div className="bg-background p-6 rounded-lg shadow-md" data-id="element-205">
              <p className="mb-2" data-id="element-206">
                <span className="text-primary font-medium" data-id="element-207">✓</span> Has
                intentado dejarlo mil veces.
              </p>
              <p className="mb-2" data-id="element-208">
                <span className="text-primary font-medium" data-id="element-209">✓</span> La culpa y
                los antojos siempre vuelven.
              </p>
            </div>
          </div>
          <div className="bg-primary/10 p-8 rounded-xl mb-8" data-id="element-210">
            <p className="text-lg mb-4" data-id="element-211">
              <span className="font-semibold" data-id="element-212">
                👉 No es falta de fuerza de voluntad.
              </span>
            </p>
            <p className="text-lg mb-4" data-id="element-213">
              <span className="font-semibold" data-id="element-214">👉 No es tu culpa.</span>
            </p>
            <p className="text-xl font-medium text-primary-dark" data-id="element-215">
              El azúcar secuestra tu cuerpo. Pero puedes recuperarlo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default ProblemSection;